/* Okashiya: interactive sections for Sense 15.5.
   Elements: ok-hero-rotator, ok-tabs, ok-hotspots, ok-add-button,
   ok-loupe, ok-hours, ok-shelf, ok-pack, ok-quiz, ok-countdown.
   Loaded once from layout/theme.liquid (defer). */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  /* ---------- Shared: add items to the cart and open Sense's cart drawer ---------- */
  function okAdd(items, button) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement && button) cart.setActiveElement(button);
    }
    if (button) { button.setAttribute('aria-busy', 'true'); button.classList.add('is-loading'); }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return res;
      })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.classList.remove('is-loading'); } });
  }
  window.okAdd = okAdd;

  function formatMoney(cents, format) {
    var v = (cents / 100);
    var two = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return none;
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return two;
    });
  }

  /* ---------- Quick add button (single variant, or a set via data-variant-ids) ---------- */
  define('ok-add-button', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (this.button) this.button.addEventListener('click', (e) => this.add(e));
    }
    add(e) {
      e.preventDefault();
      if (this.button.disabled || this.button.classList.contains('is-loading')) return;
      var ids = (this.dataset.variantIds || this.dataset.variantId || '').split(',').filter(Boolean);
      if (!ids.length) return;
      okAdd(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), this.button).catch((err) => {
        this.button.textContent = this.dataset.errorLabel || 'Unavailable';
        console.warn('[okashiya] add failed', err);
      });
    }
  });

  /* ---------- Rotating hero ---------- */
  define('ok-hero-rotator', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ok-slide]'));
      this.tabs = Array.from(this.querySelectorAll('[data-ok-tab]'));
      this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.style.setProperty('--ok-speed', this.speed + 'ms');
      this.index = 0;
      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => { this.go(i); this.restart(); }));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.restart());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.restart()));
      this.go(0);
      this.restart();
    }
    disconnectedCallback() { this.pause(); }
    go(i) {
      this.index = i;
      this.slides.forEach((s, n) => {
        var on = n === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a, button, video').forEach((el) => {
          if (el.tagName === 'VIDEO') { if (on) { if (el.play) el.play().catch(function () {}); } else if (el.pause) { el.pause(); } }
          else el.tabIndex = on ? 0 : -1;
        });
      });
      this.tabs.forEach((t, n) => { t.classList.toggle('is-active', n === i); t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      var bar = this.tabs[i] && this.tabs[i].querySelector('.ok-rot__bar-fill');
      if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
    }
    next() { this.go((this.index + 1) % this.slides.length); }
    pause() { clearInterval(this.timer); this.classList.add('is-paused'); }
    restart() {
      clearInterval(this.timer);
      this.classList.remove('is-paused');
      if (reduceMotion || this.dataset.autoplay === 'false' || this.slides.length < 2) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }
  });

  /* ---------- Tabs ---------- */
  define('ok-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(n); this.tabs[n].focus();
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, n) => { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
      this.panels.forEach((p, n) => {
        p.hidden = n !== i;
        if (n === i) { p.classList.remove('ok-fade-in'); void p.offsetWidth; p.classList.add('ok-fade-in'); }
      });
    }
  });

  /* ---------- Hotspots ---------- */
  define('ok-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-ok-spot]'));
      this.buttons.forEach((b) => b.addEventListener('click', () => this.toggle(b.dataset.okSpot)));
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.toggle(null); });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.toggle(null); });
    }
    toggle(id) {
      this.buttons.forEach((b) => {
        var on = id !== null && b.dataset.okSpot === id && b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        var card = document.getElementById(b.getAttribute('aria-controls'));
        if (card) card.hidden = !on;
      });
    }
  });

  /* ---------- Shared scroll loop for scroll-driven sections ---------- */
  var scrollers = new Set(), ticking = false;
  function runScroll() { ticking = false; scrollers.forEach(function (s) { s.update(); }); }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { scrollers.forEach(function (s) { if (s.resize) s.resize(); }); onScroll(); });
  function progress(el, inner) {
    var b = el.getBoundingClientRect();
    var total = el.offsetHeight - inner.offsetHeight;
    var top = parseFloat(getComputedStyle(inner).top) || 0;
    return total > 0 ? Math.min(1, Math.max(0, (top - b.top) / total)) : 0;
  }

  /* ---------- Loupe hero ---------- */
  define('ok-loupe', class extends HTMLElement {
    connectedCallback() {
      this.soft = this.querySelector('[data-soft]');
      this.hint = this.querySelector('[data-hint]');
      this.tx = 0.72; this.ty = 0.5; this.cx = this.tx; this.cy = this.ty; this.last = 0; this.visible = true;
      var move = (e) => {
        var b = this.soft.getBoundingClientRect(), pt = e.touches ? e.touches[0] : e;
        this.tx = Math.min(1, Math.max(0, (pt.clientX - b.left) / b.width));
        this.ty = Math.min(1, Math.max(0, (pt.clientY - b.top) / b.height));
        this.last = performance.now();
        if (this.hint && this.dataset.focused !== '1') { this.dataset.focused = '1'; this.hint.style.opacity = '0'; }
      };
      this.addEventListener('pointermove', move);
      this.addEventListener('touchmove', move, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver((en) => { this.visible = en[0].isIntersecting; }).observe(this);
      var tick = (t) => {
        if (!this.isConnected) return;
        if (this.visible) {
          if (!reduceMotion && t - this.last > 2200) {
            var mob = this.clientWidth < 750;
            this.tx = (mob ? 0.5 : 0.7) + Math.sin(t / 2600) * (mob ? 0.22 : 0.16);
            this.ty = 0.5 + Math.sin(t / 1900) * 0.18;
          }
          this.cx += (this.tx - this.cx) * 0.09; this.cy += (this.ty - this.cy) * 0.09;
          var r = Math.max(90, Math.min(170, this.clientWidth * 0.12));
          this.style.setProperty('--r', r + 'px');
          this.style.setProperty('--x', Math.round(this.cx * this.soft.offsetWidth) + 'px');
          this.style.setProperty('--y', Math.round(this.cy * this.soft.offsetHeight) + 'px');
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      var words = (this.dataset.words || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var rot = this.querySelector('[data-rot]'), wi = 0;
      if (rot && words.length > 1 && !reduceMotion) {
        this.rotTimer = setInterval(function () {
          rot.classList.add('is-out');
          setTimeout(function () { wi = (wi + 1) % words.length; rot.textContent = words[wi]; rot.classList.remove('is-out'); }, 600);
        }, 2600);
      }
      this.querySelectorAll('a[href="#"]').forEach((a) => a.addEventListener('click', (e) => {
        e.preventDefault();
        var sec = this.closest('.shopify-section');
        var next = sec && sec.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      }));
    }
    disconnectedCallback() { clearInterval(this.rotTimer); }
  });

  /* ---------- Soft hours ---------- */
  function hex(h) { h = (h || '#FAF6F0').replace('#', ''); return [0, 2, 4].map(function (k) { return parseInt(h.substr(k, 2), 16); }); }
  function mix(a, b, t) { var A = hex(a), B = hex(b); return 'rgb(' + A.map(function (v, k) { return Math.round(v + (B[k] - v) * t); }).join(',') + ')'; }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60) % 24, m = Math.floor(mins % 60), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return (h12 < 10 ? '0' : '') + h12 + ':' + (m < 10 ? '0' : '') + m + '<small>' + ap + '</small>';
  }
  define('ok-hours', class extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.sun = this.querySelector('[data-sun]');
      this.clock = this.querySelector('[data-clock]');
      this.label = this.querySelector('[data-label]');
      this.cards = Array.from(this.querySelectorAll('[data-hour]'));
      this.rail = Array.from(this.querySelectorAll('[data-jump]'));
      this.baseLabel = this.label ? this.label.textContent : '';
      this.H = this.cards.map(function (c) { return { m: +c.dataset.mins || 0, sky: c.dataset.sky, sun: c.dataset.sun, dark: c.dataset.dark === 'true', name: c.dataset.name }; });
      if (!this.H.length) return;
      this.start = this.H[0].m; this.end = this.H[this.H.length - 1].m + 60;
      if (this.end <= this.start) this.end = this.start + 60;
      this.cur = -1;
      this.rail.forEach((b) => b.addEventListener('click', () => {
        var i = +b.dataset.jump, p = (i + 0.04) / this.H.length;
        var top = window.scrollY + this.getBoundingClientRect().top + p * (this.offsetHeight - this.stage.offsetHeight);
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      }));
      scrollers.add(this); this.update();
    }
    disconnectedCallback() { scrollers.delete(this); }
    update() {
      var H = this.H; if (!H || !H.length) return;
      /* Every moment gets an equal share of the scroll, however close together the clock times are. */
      var p = progress(this, this.stage), n = H.length, seg = Math.min(n - 0.0001, Math.max(0, p * n)), i = Math.floor(seg), local = seg - i;
      var next = H[Math.min(i + 1, n - 1)], last = next === H[i];
      var until = last ? H[i].m + 60 : (next.m > H[i].m ? next.m : H[i].m + 60);
      var mins = H[i].m + local * (until - H[i].m);
      var blend = last ? 0 : Math.max(0, (local - 0.7) / 0.3);
      var dark = blend > 0.5 ? next.dark : H[i].dark;
      this.stage.style.setProperty('--sky', mix(H[i].sky, next.sky, blend));
      this.stage.style.setProperty('--ink', dark ? '#FAF6F0' : '#3B2F2A');
      this.stage.style.setProperty('--sun', blend > 0.5 ? next.sun : H[i].sun);
      this.classList.toggle('is-dark', dark);
      var arc = Math.min(1, Math.max(0, (mins - this.start) / (Math.max(this.end - 120, this.start + 60) - this.start)));
      this.sun.style.setProperty('--sx', (8 + arc * 84) + '%');
      this.sun.style.setProperty('--sy', (74 - Math.sin(Math.PI * arc) * 60) + '%');
      this.clock.innerHTML = fmtTime(Math.round(mins / 5) * 5);
      if (i !== this.cur) {
        this.cur = i;
        this.cards.forEach(function (c, n) { c.classList.toggle('is-on', n === i); });
        this.rail.forEach(function (r, n) { if (n === i) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current'); });
        if (this.label) this.label.textContent = this.baseLabel + (H[i].name ? ' · ' + H[i].name.toLowerCase() : '');
      }
    }
  });

  /* ---------- The edit shelf ---------- */
  var wide = window.matchMedia('(min-width: 901px)');
  define('ok-shelf', class extends HTMLElement {
    connectedCallback() {
      this.pin = this.querySelector('[data-pin]');
      this.track = this.querySelector('[data-track]');
      this.meter = this.querySelector('[data-meter]');
      this.count = this.querySelector('[data-count]');
      this.n = this.track.children.length;
      this.track.addEventListener('click', (e) => {
        var t = e.target.closest('[data-turn]'); if (!t) return;
        var card = t.closest('.oks-card'), on = card.classList.toggle('is-flipped');
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      scrollers.add(this);
      this.resize();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { this.resize(); this.update(); });
      window.addEventListener('load', () => { this.resize(); this.update(); });
    }
    disconnectedCallback() { scrollers.delete(this); }
    resize() {
      if (!wide.matches) { this.style.height = ''; this.track.style.transform = ''; return; }
      this.dist = Math.max(0, this.track.scrollWidth - window.innerWidth);
      this.style.height = (this.pin.offsetHeight + this.dist) + 'px';
      this.update();
    }
    update() {
      if (!wide.matches) return;
      var p = progress(this, this.pin);
      this.track.style.transform = 'translate3d(' + (-p * (this.dist || 0)) + 'px,0,0)';
      if (this.meter) this.meter.style.setProperty('--ep', p);
      if (this.count) { var k = Math.min(this.n, Math.floor(p * (this.n - 1) + 1.5)); this.count.textContent = (k < 10 ? '0' : '') + k + ' / ' + (this.n < 10 ? '0' : '') + this.n; }
    }
  });

  /* ---------- Pack your bag ---------- */
  define('ok-pack', class extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('.oks-tile'));
      this.bag = this.querySelector('[data-bag]');
      this.empty = this.querySelector('[data-empty]');
      this.fill = this.querySelector('[data-fill]');
      this.total = this.querySelector('[data-total]');
      this.goal = this.querySelector('[data-goal]');
      this.btn = this.querySelector('[data-add-all]');
      this.threshold = +this.dataset.threshold || 0;
      this.live = this.dataset.live === 'true';
      this.btnLabel = this.btn.textContent;
      this.tiles.forEach((t) => t.addEventListener('click', () => {
        t.setAttribute('aria-pressed', t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        this.render();
      }));
      this.btn.addEventListener('click', () => {
        var sel = this.selected(); if (!sel.length) return;
        if (!this.live) { this.btn.textContent = 'Preview only'; setTimeout(() => this.render(), 1600); return; }
        okAdd(sel.map(function (t) { return { id: Number(t.dataset.id), quantity: 1 }; }), this.btn).catch(() => { this.btn.textContent = 'Some items are unavailable'; });
      });
      this.render();
    }
    selected() { return this.tiles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; }); }
    render() {
      var sel = this.selected(), ids = sel.map(function (t) { return t.dataset.id; });
      Array.from(this.bag.querySelectorAll('.oks-bag__item')).forEach(function (n) { if (ids.indexOf(n.dataset.id) < 0) n.remove(); });
      sel.forEach((t) => {
        if (this.bag.querySelector('[data-id="' + t.dataset.id + '"]')) return;
        var it = document.createElement('div');
        it.className = 'oks-bag__item'; it.dataset.id = t.dataset.id; it.style.background = t.dataset.bg || '#ECEAE6';
        it.textContent = t.dataset.name; it.style.flexBasis = (34 + (t.dataset.name.length % 5) * 8) + '%';
        this.bag.appendChild(it);
      });
      this.empty.hidden = sel.length > 0;
      var cents = sel.reduce(function (s, t) { return s + (+t.dataset.price || 0); }, 0), fmt = this.dataset.moneyFormat;
      this.total.textContent = formatMoney(cents, fmt);
      if (this.threshold > 0) {
        this.fill.style.width = Math.min(100, cents / this.threshold * 100) + '%';
        this.goal.textContent = cents >= this.threshold ? this.dataset.doneLabel : (this.dataset.goalLabel || '').replace('[amount]', formatMoney(this.threshold - cents, fmt));
      } else { this.fill.style.width = sel.length ? '100%' : '0'; this.goal.textContent = ''; }
      this.btn.disabled = sel.length === 0;
      this.btn.textContent = sel.length ? this.btnLabel + ' (' + sel.length + ')' : this.btnLabel;
    }
  });

  /* ---------- Ritual quiz ---------- */
  define('ok-quiz', class extends HTMLElement {
    connectedCallback() {
      this.qs = Array.from(this.querySelectorAll('[data-q]'));
      this.results = Array.from(this.querySelectorAll('[data-result]'));
      this.steps = Array.from(this.querySelectorAll('.oks-quiz__steps i'));
      this.answers = [];
      this.addEventListener('click', (e) => {
        var a = e.target.closest('[data-answer]');
        if (a) { this.answers.push(a.dataset.answer); this.show(); return; }
        if (e.target.closest('[data-restart]')) { this.answers = []; this.show(); }
      });
      this.show();
    }
    show() {
      var n = this.answers.length;
      this.steps.forEach(function (s, i) { s.classList.toggle('is-done', i < n); });
      this.qs.forEach(function (q, i) { q.hidden = i !== n; });
      var winner = null;
      if (n >= this.qs.length && n > 0) {
        var tally = {}; this.answers.forEach(function (a) { tally[a] = (tally[a] || 0) + 1; });
        winner = Object.keys(tally).sort(function (x, y) { return tally[y] - tally[x]; })[0];
        if (tally[winner] === 1) winner = this.answers[0];
      }
      this.results.forEach(function (r) { r.hidden = r.dataset.result !== winner; });
      var shown = winner ? this.querySelector('[data-result="' + winner + '"] h2') : (this.qs[n] && this.qs[n].querySelector('h2'));
      if (shown && n > 0) { shown.setAttribute('tabindex', '-1'); shown.focus({ preventScroll: true }); }
    }
  });

  /* ---------- Drop countdown ---------- */
  define('ok-countdown', class extends HTMLElement {
    connectedCallback() {
      this.el = { d: this.querySelector('[data-d]'), h: this.querySelector('[data-h]'), m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]') };
      this.target = this.next();
      this.tick(); this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    next() {
      var wd = +this.dataset.weekday, hr = +this.dataset.hour, off = +this.dataset.offset;
      var now = new Date();
      var local = new Date(now.getTime() + off * 3600000); // shifted "wall clock" in the drop time zone, read with UTC getters
      var t = new Date(Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), hr, 0, 0));
      t.setUTCDate(t.getUTCDate() + ((wd - t.getUTCDay() + 7) % 7));
      var real = new Date(t.getTime() - off * 3600000);
      if (real <= now) real = new Date(real.getTime() + 7 * 86400000);
      return real;
    }
    tick() {
      var ms = this.target - new Date();
      if (ms <= 0) { this.target = this.next(); ms = this.target - new Date(); }
      var s = Math.floor(ms / 1000), pad = function (v) { return (v < 10 ? '0' : '') + v; };
      this.el.d.textContent = Math.floor(s / 86400);
      this.el.h.textContent = pad(Math.floor(s / 3600) % 24);
      this.el.m.textContent = pad(Math.floor(s / 60) % 60);
      this.el.s.textContent = pad(s % 60);
    }
  });

  if (wide.addEventListener) wide.addEventListener('change', function () { scrollers.forEach(function (s) { if (s.resize) s.resize(); }); onScroll(); });
})();
